import React, { useState, useEffect } from 'react';
import GetHeroVideo from './GetHeroVideo'
import videoAlt from '../../videos/entanglement.mp4'
import {
  HeroContainer,
  HeroBg,
  VideoBg,
  HeroContent,
  HeroH1,
  HeroP,
  HeroBtnWrapper,
  ArrowForward,
  ArrowRight,
  Button
} from './HeroElements';

function HeroSection() {
  const [hover, setHover] = useState(false);
  const [hover2, setHover2] = useState(false);
  const [video, setVideo] = useState({ fileUrl: '' });

  useEffect(() => {
    GetHeroVideo().then(vid => setVideo({ fileUrl: vid }));
  }, []);


  const onHover = () => {
    setHover(!hover);
  };

  const onHover2 = () => {
    setHover2(!hover2);
  };


  return (
    <HeroContainer id='home'>
      <HeroBg>
        <>
          {video.fileUrl == '' ? <VideoBg playsInline autoPlay loop muted src={videoAlt} type='video/mp4' />
            : (<VideoBg playsInline autoPlay loop muted src={video.fileUrl} type='video/mp4' />)}
        </>
      </HeroBg>
      <HeroContent>
        <HeroH1 isDark={video.fileUrl == ''}>Cash Crew</HeroH1>
        <HeroP isDark={video.fileUrl == ''}>
          Take your Daily Fantasy team to the next level using our crew builder. Select your crew using insights from our team optimizers and see how your teams stack up against projections.
        </HeroP>
        <HeroBtnWrapper>
          <Button
            to="/crewbuilder"
            smooth={true}
            duration={500}
            spy={true}
            exact={true}
            primary={true}
            dark={true}
            onMouseEnter={onHover2}
            onMouseLeave={onHover2}
          >
            Crew Builder {hover ? <ArrowForward /> : <ArrowRight />}
          </Button>
          <Button
            to="/cashcrewagentic"
            smooth={true}
            duration={500}
            spy={true}
            exact={true}
            primary={true}
            dark={true}
            onMouseEnter={onHover2}
            onMouseLeave={onHover2}
          >
            Playmaker AI{hover2 ? <ArrowForward /> : <ArrowRight />}
          </Button>
          {/* <Button
            to="/poolparty"
            smooth={true}
            duration={500}
            spy={true}
            exact={true}
            primary={true}
            dark={true}
            onMouseEnter={onHover2}
            onMouseLeave={onHover2}
          >
            Pool Party {hover2 ? <ArrowForward /> : <ArrowRight />}
          </Button> */}
        </HeroBtnWrapper>
      </HeroContent>
    </HeroContainer>
  );
}

export default HeroSection;
